module.exports = __webpack_public_path__ + "img/groups.104c670d.svg";